import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, helperMargin, Typography, Button, IconSvg, Hint } from '@utex/ui-kit';
import { Layout } from '../../components/Layout';
import { ModalContext } from '../../modalsContext';
import { useContentState } from './hooks/useContentState';
import { ContentProps } from '../../types/common';

export const Content: React.FC<ContentProps> = () => {
  const { t } = useTranslation('byUTT');
  const { onRequestClose } = useContext(ModalContext);
  const { isButtonSuccessStatus, loading, loadAddress, address, error } = useContentState();

  return (
    <Layout.Form>
      <Layout.FormContent>
        <Box display={{ phonablet: 'flex' }} flexDirection={{ phonablet: 'column' }}>
          <Typography.Paragraph
            size={{ tablesktop: 'L', phonablet: 'M' }}
            weight="bold"
            css={helperMargin({ bottom: 10 })}
          >
            {t('Send UTT tokens to address')}
          </Typography.Paragraph>
          {isButtonSuccessStatus ? (
            <Button disabled view="success" icon={<IconSvg src="check" />} iconPosition="left">
              {t('Address copied')}
            </Button>
          ) : (
            <Button
              onClick={() => loadAddress()}
              view="alert"
              icon={<IconSvg src="copy" />}
              iconPosition="left"
              isLoading={loading}
            >
              {t('Copy Address')}
            </Button>
          )}
        </Box>

        {error && (
          <Box marginTop={10}>
            <Hint view="error" textAlign="center">
              {t('error')}
            </Hint>
          </Box>
        )}

        {address && (
          <>
            <Typography.Paragraph size="M" view="hint" css={helperMargin({ top: 10 })}>
              {t('Address copied')}
            </Typography.Paragraph>
            <Typography.Text size="M">{address}</Typography.Text>
          </>
        )}
      </Layout.FormContent>

      <Layout.FormFooter>
        <Button view="regular" onClick={onRequestClose}>
          {t('Done')}
        </Button>
        <Typography.Paragraph
          size="M"
          view="hint"
          css={helperMargin({ left: { tablesktop: 15 }, bottom: { phonablet: 10 } })}
        >
          {t('The balance will update after several block confirmations on the network')}
        </Typography.Paragraph>
      </Layout.FormFooter>
    </Layout.Form>
  );
};
